import { SelectOption } from 'models';

export function isSelectOption(item: unknown): item is SelectOption {
  return (
    item &&
    Boolean((item as SelectOption).value) &&
    Boolean((item as SelectOption).label)
  );
}
